export default {
    props: {
        open: {
            type: Boolean,
            default: false,
        }
    },
    data() {
      return {
        innerOpen: this.open,
        desktop: window.innerWidth >= 1024
      };
    },
    mounted(){
      window.addEventListener('resize', (e) => {
       this.desktop = innerWidth >= 1024;
       !this.desktop ? this.innerOpen = false : this.innerOpen = true;      
      });

      !this.desktop
        ? this.innerOpen = false
        : this.innerOpen = true;      
    },
    methods: {
      toggle() {
        this.innerOpen = !this.innerOpen;
      },
      startTransition(el) {
        el.style.height = el.scrollHeight + "px";
      },  
      endTransition(el) {
        el.style.height = "";
      },
    },
    watch: {
      open(value) {
        this.innerOpen = value;
      },
    },
  };